import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SecondaryActionDashboardService {

  constructor(private http: HttpClient) { }

  getJsonData(
    baseUrl: string,
    trackingKey: string | number
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject?action_code=as2mqg&tracking_key=${trackingKey}`;
    return this.http.get<any>(url, { withCredentials: true });
  }
}
